//-------------------------------------------------( Imports )
import React, { Component } from 'react'
import BackgroundTools from 'src/utils/background'

import { TweenMax, TimelineMax } from 'gsap'

//-------------------------------------------------( Helpers )
import resize from 'src/utils/resize'
import values from 'src/values'

import './style.scss'

//-------------------------------------------------( Class )
export default class Cover extends Component {
  constructor(props) {
    super(props)

    this.key = `cover${Math.random()}`

    this.state = {
      src: null
    }
  }

  componentDidMount() {
    this.preload()

    resize.add(this.onResize, this.key)
  }

  componentDidUpdate() {
    this.onResize()
  }

  preload() {
    this.img = new Image()
    this.img.src = this.props.src
    this.img.onload = () => {
      this.setState({
        src: this.props.src
      })
    }
  }

  hide() {
    TweenMax.to(this.refs.component, 0.3, {
      opacity: 0
    })
  }

  onResize = () => {
    if (!this.refs.bg || !this.refs.component || !this.img) return

    const b = BackgroundTools.cover(
      this.img.naturalWidth,
      this.img.naturalHeight,
      this.refs.component.clientWidth,
      this.refs.component.clientHeight
    )

    TweenMax.set(this.refs.bg, {
      z: 0,
      x: b.x || 0,
      y: b.y || 0,
      width: b.width || 0,
      height: b.height || 0
    })
  }

  render() {
    return (
      <div ref="component" className="cover-img">
        <img ref="bg" src={this.state.src} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/cover-img/index.js